import React from 'react';

import { useTranslation } from '../i18n';
import { ConnectedEntityPickerModalProps as EntityPickerModalProps } from '../modal/ConnectedEntityPickerModal';
import EntityPickerModal from '../modal/EntityPickerModal';
import docsPlugin from '../plugins/docs';
import { EntityWithId } from '../types/types';

type CopyAttachmentsFromProjectFilesModalProps<T> = Omit<
  EntityPickerModalProps<T>,
  'onSave' | 'multiple'
> & {
  onClose?: () => void;
  onSave: (selectedEntities: T[]) => Promise<void> | void;
  multiple?: boolean;
};

const CopyAttachmentsFromProjectFilesModal = <T extends EntityWithId>({
  open,
  onClose,
  onSave,
  isSaving,
  ...rest
}: CopyAttachmentsFromProjectFilesModalProps<T>) => {
  const { t } = useTranslation();
  const customDocsPlugin = {
    ...docsPlugin,
    PickerModalTitle: () => t('MODAL_ADD_ATTACHMENTS'),
    AddRelationshipsButtonText: () => t('MODAL_ATTACH_A_COPY'),
  };

  return (
    <EntityPickerModal<T>
      open={open}
      closeModal={onClose}
      plugin={customDocsPlugin}
      isSaving={isSaving}
      loading={false}
      error={false}
      allowCreate={false}
      onSave={onSave}
      {...rest}
      multiple={true}
    />
  );
};

export default CopyAttachmentsFromProjectFilesModal;
